import React from "react";
import SectionHeader from "../components/SectionHeader";

const FounderJourneySection = ({ data }) => (
    
    <section className="founder-journey">

        <div className="container">

            {/* =================================================
                 HEADER
            ================================================== */}

            {console.log("FOUNDER JOURNEY DATA::::", data)}

            <SectionHeader
                eyebrow={data.eyebrow}
                title={data.title}
                highlight={data.highlight}
                description={data.description}
            />


            {/* =================================================
                 PERSONAL JOURNEY
            ================================================== */}

            <div className="journey-story">

                {(data.items || []).map((item, i) => (
                    <article
                        className={`journey-story-item ${
                            item.highlight
                                ? "journey-highlight"
                                : ""
                        }`}
                        key={i}
                    >

                        <div className="journey-story-meta">

                            <span className="journey-number">
                                {item.number}
                            </span>

                            <span className="journey-period">
                                {item.period}
                            </span>

                        </div>


                        <div className="journey-story-content">

                            {item.tag && (
                                <span className="journey-tag">
                                    {item.tag}
                                </span>
                            )}

                            <h3>
                                {item.title}
                            </h3>

                            {(item.paragraphs || []).map(
                                (paragraph, p) => (
                                    <p key={p}>
                                        {paragraph}
                                    </p>
                                )
                            )}

                        </div>

                    </article>
                ))}

            </div>
        </div>

    </section>
);

export default FounderJourneySection;